import {
  Component,
  OnInit,
  PLATFORM_ID,
  Inject,
  LOCALE_ID,
  AfterViewInit
} from "@angular/core";
import { FacadeService } from "../../service/facade.service";
import { isPlatformBrowser } from "@angular/common";
import { Router, Params, ActivatedRoute } from "@angular/router";
import { LinkService } from "../../service/link.service";
import { Title, Meta } from "@angular/platform-browser";
import { SEO } from "../../models/seo/seoInterface";
import { seoManagement } from "../../models/seo/seoClass";
import { Content } from "@angular/compiler/src/render3/r3_ast";

class ContactUsData {
  phone: string = "";
  facebook: string = "";
  email: string = "";
  location: string = "";
}

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"]
})
export class ContactUsComponent extends seoManagement
  implements OnInit, SEO, AfterViewInit {
  contactUsData: ContactUsData;
  isBrowser: boolean;
  branchdata: any;
  title;
  image;
  contactdata;
  currentLang: string;
  loading = true;
  selectedId: number;
  contactus: string;
  description: string;
  url: string;
  currentLangId: string;
  afterLoad: boolean;
  constructor(
    private _FacadeService: FacadeService,
    private router: Router,
    private route: ActivatedRoute,
    public link: LinkService,
    @Inject(LOCALE_ID) local,
    @Inject(PLATFORM_ID) private platfromId,
    public titleService: Title,
    public metaService: Meta
  ) {
    super(
      titleService,
      metaService,
      isPlatformBrowser(platfromId),
      local,
      link
    );
    this.currentLang = local;
    this.isBrowser = isPlatformBrowser(this.platfromId);
  }

  ngOnInit() {
    this.setSeoTagsProperties();
    this.getbranchesdata();
    this.btnClick(1);
  }
  ngAfterViewInit() {
    this.afterLoad = true;
    // this.setSeoTagsProperties();
    // this.setSeoTags(this.contactus, this.description, '', location.href, location.pathname);
  }
  getbranchesdata() {
    this._FacadeService.About.Branches.subscribe(res => {
      this.branchdata = res.data;
    });
  }

  btnClick(branchId) {
    this.selectedId = branchId;
    this.loading = true;
    this._FacadeService.About.getContact(branchId).subscribe(data => {
      this.contactdata = data.data;
      this.loading = false;
    });
  }
  setSeoTagsProperties() {
    const currentUrlLang = this.currentLangId === "en" ? "" : "ar/";
    if (this.currentLangId === "ar") {
      this.title = "نيو فرنتشر للاثاث المكتبي";
      this.description =
        "نحن متخصصون في المنتجات الراقية لجميع أنواع أثاث المكاتب. تفضل بزيارتنا في 42 شارع نجيب محفوظ - مكرم عبيد - مدينة نصر";
    } else {
      this.title = "New furniture Egypt office furniture company";
      this.description =
        "We are specialist of the fine products of all kind of office furniture. Visit us in 42 naguib mahfouz st - makram ebeid - nasr city ";
    }
    this.url =
      "https://www.newfurniture-eg.com/" + currentUrlLang + "contact-us";
    this.link.addTag({
      rel: "",
      href: this.url
    });

    this.setSeoTags(this.title, this.description, this.image, this.url);
  }
}
